import axios from "axios";
import { toast } from "react-toastify";
import { lang } from "./lang";

const notifyError = (message: string) => toast.error(message);
const notifySuccess = (message: string) => toast.success(message);
const token = localStorage.getItem("access_token");
let axiosConfig = {} as any;
if (token) {
  axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

const request = axios.create(axiosConfig);
let requestNumber = 0;
request.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 201) {
      if (response.config.method === "post") {
        if (
          response.config.url &&
          response.config.url !== "/api/logout" &&
          response.config.url !== "/api/login"
        )
          notifySuccess(lang.successfullyAdded);
      }
      if (response.config.method === "put") {
        notifySuccess(lang.successfullyUpdated);
      }
      if (response.config.method === "delete") {
        if (response.config.url) notifySuccess(lang.successfullyDeleted);
      }
    } else {
      //
    }
    requestNumber--;
    if (requestNumber === 0) {
      const element = document.getElementById("loading");
      element?.classList.remove("loading");
      element?.classList.add("loadingDisabled");
    }
    return response;
  },
  (error) => {
    requestNumber--;
    if (error.response.status && error.response.status === 401) {
      localStorage.setItem("useId", "");
      localStorage.setItem("userName", "");
      localStorage.setItem("userEmail", "");
      localStorage.setItem("access_token", "");
      localStorage.setItem("cacheData", "");
      localStorage.setItem("permissions", "");
      localStorage.setItem("roles", "");
      document.cookie = "accept_notification =; ";
      window.location.href = "/login";
    }
    if (error.response.data && error.response.data !== "")
      notifyError(error.response.data);
    else {
      if (error.config.method === "post") {
        notifyError(lang.addError);
      }
      if (error.config.method === "put") {
        notifyError(lang.updateError);
      }
      if (error.config.method === "delete") {
        notifyError(lang.deleteError);
      }
    }
    const element = document.getElementById("loading");
    element?.classList.remove("loading");
    element?.classList.add("loadingDisabled");
  }
);

request.interceptors.request.use(
  (config) => {
    requestNumber++;
    const element = document.getElementById("loading");
    element?.classList.remove("loadingDisabled");
    element?.classList.add("loading");
    return config;
  },
  (error) => {
    const element = document.getElementById("loading");
    element?.classList.remove("loading");
    element?.classList.add("loadingDisabled");
  }
);

export default request;
